import script from "./RedeemForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RedeemForm.vue?vue&type=script&setup=true&lang=js"

import "./RedeemForm.vue?vue&type=style&index=0&id=ee251abc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee251abc"]])

export default __exports__